module.exports = __webpack_public_path__ + "img/no-content-penguin.6fca0e30.svg";